import { useState } from "react";
import { CODE_SAMPLES } from "@/mocks/ecfMocks";
import CodeBlock from "@/components/base/CodeBlock";
import { ArrowRight } from "lucide-react";
import { publicDocsUrl } from "@/lib/docs";

const TABS = [
  { key: "curl", label: "cURL" },
  { key: "python", label: "Python (SDK)" },
  { key: "csharp", label: "C# (.NET SDK)" },
  { key: "node", label: "Node.js" },
] as const;

type TabKey = keyof typeof CODE_SAMPLES;

export default function IntegrationTabs() {
  const [active, setActive] = useState<TabKey>("curl");

  return (
    <section id="integraciones" className="bg-white py-24 px-4 md:px-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10">
          <span className="inline-flex items-center px-3 py-1 rounded-full border border-slate-200 text-xs font-semibold uppercase tracking-widest text-slate-500 mb-4">
            Integración rápida
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3">
            Integra en minutos
          </h2>
          <p className="text-slate-500 text-base">
            Un solo endpoint REST. Autenticación por API Key. Cualquier lenguaje, cualquier ERP.
          </p>
        </div>

        {/* Tabs */}
        <div className="flex items-center justify-center gap-2 mb-6">
          <div className="inline-flex bg-slate-100 rounded-full p-1">
            {TABS.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActive(tab.key)}
                className={`px-4 py-1.5 text-sm font-medium rounded-full transition-all cursor-pointer whitespace-nowrap ${
                  active === tab.key
                    ? "bg-white text-slate-900 shadow-sm"
                    : "text-slate-500 hover:text-slate-700"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
        </div>

        {/* Code block */}
        <CodeBlock
          code={CODE_SAMPLES[active]}
          language={active === "curl" ? "bash" : active === "node" ? "javascript" : active}
          className="text-sm"
        />

        {/* CTA */}
        <div className="text-center mt-8">
          <a
            href={publicDocsUrl()}
            className="inline-flex items-center gap-2 bg-blue-800 text-white font-semibold px-6 py-3 rounded-full hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap"
          >
            Ver documentación completa
            <ArrowRight size={16} />
          </a>
        </div>
      </div>
    </section>
  );
}